import list from './list'
import getNode from './getNode'
import regenerate from './regenerate'
import disable from './disable'
import enable from './enable'
import update from './update'
import sendSlackInstructions from './sendSlackInstructions'

export default {
  list,
  getNode,
  regenerate,
  disable,
  enable,
  update,
  sendSlackInstructions,
}
